import { useQuery } from '@tanstack/react-query';

import type { PaymentErrorCodesResponse } from '@models/paymentErrorCodes';

import { getAllPaymentErrorCodes, getAllPaymentErrorCodesPaginated } from './api';

export function useAllPaymentErrorsCodesPaginated(page: number, isFiltered: boolean = false) {
  return useQuery<PaymentErrorCodesResponse>({
    queryKey: ['paginatedErrorCodes', page, isFiltered],
    queryFn: () => getAllPaymentErrorCodesPaginated(page, isFiltered),
  });
}

export function useAllPaymentErrorCodes(isFiltered: boolean = false) {
  return useQuery<PaymentErrorCodesResponse>({
    queryKey: ['allPaymentsErrorCodes', isFiltered],
    queryFn: () => getAllPaymentErrorCodes(isFiltered),
  });
}
